var _circle, _path, _path2, _rect, _circle2, _circle3, _circle4, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSlotsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 124,
    viewBox: "0 0 226 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 50,
    cy: 61,
    r: 50,
    fill: "url(#paint0_linear_5807_10824)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M166.041 112.735L70.3369 112.735L70.3369 57.3879L166.041 112.735Z",
    fill: "url(#paint1_linear_5807_10824)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0408 117.347C53.0408 114.318 53.6373 111.319 54.7963 108.522C55.9552 105.724 57.6539 103.181 59.7953 101.04C61.9367 98.8985 64.479 97.1998 67.2769 96.0409C70.0748 94.882 73.0736 94.2855 76.1021 94.2855L76.102 117.347L53.0408 117.347Z",
    fill: "#353558"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 133.755,
    y: 35.4795,
    width: 28.8265,
    height: 28.8265,
    rx: 14.4133,
    fill: "url(#paint2_linear_5807_10824)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.1999,
    cy: 20.7034,
    r: 1.15306,
    fill: "url(#paint3_linear_5807_10824)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.8118,
    cy: 20.7034,
    r: 1.15306,
    fill: "#353558"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.4241,
    cy: 20.7034,
    r: 1.15306,
    fill: "#0061FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.339,
    y: 13.8596,
    width: 149.321,
    height: 96.2806,
    stroke: "url(#paint4_linear_5807_10824)",
    strokeWidth: 0.576531
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7451,
    y: 11.2651,
    width: 4.61225,
    height: 4.61225,
    fill: "#0061FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7451,
    y: 108.123,
    width: 4.61225,
    height: 4.61225,
    fill: "#0061FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 185.643,
    y: 11.2651,
    width: 4.61225,
    height: 4.61225,
    fill: "#0061FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 185.643,
    y: 108.123,
    width: 4.61225,
    height: 4.61225,
    fill: "#0061FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M209.024 110.924C210.138 113.614 210.727 116.492 210.759 119.403H187.949L165.139 119.403C165.171 116.492 165.76 113.614 166.874 110.924C168.02 108.156 169.701 105.641 171.819 103.523C173.937 101.405 176.452 99.7246 179.219 98.5782C181.987 97.4318 184.953 96.8418 187.949 96.8418C190.945 96.8418 193.911 97.4318 196.678 98.5782C199.446 99.7246 201.961 101.405 204.079 103.523C206.197 105.641 207.877 108.156 209.024 110.924Z",
    stroke: "url(#paint5_linear_5807_10824)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5807_10824",
    x1: 90.1977,
    y1: 83.0872,
    x2: -16.1479,
    y2: 27.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06D8DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5807_10824",
    x1: 196.057,
    y1: 194.803,
    x2: 41.5092,
    y2: 110.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5807_10824",
    x1: 133.651,
    y1: 41.2779,
    x2: 162.542,
    y2: 72.0228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5807_10824",
    x1: 46.3402,
    y1: 21.8564,
    x2: 42.7329,
    y2: 20.7029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5807_10824",
    x1: 113,
    y1: 13.5713,
    x2: 113,
    y2: 110.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#625E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5807_10824",
    x1: 187.949,
    y1: 96.5918,
    x2: 187.949,
    y2: 119.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#625E98"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSlotsIcon);
export default __webpack_public_path__ + "static/media/no-slots-icon.430f7ae8.svg";
export { ForwardRef as ReactComponent };